import React from 'react'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';
import Box from '@mui/material/Box';


export default function MyDatePicker(props) {

    const { name, label, value, onChange, disabled, readOnly, disableOpenPicker, error = null, helperText, views, format, minDate = '2020-01', size = "large" } = props


    const handleDateChange = (newValue) => {
        if (newValue) {
            // Upewnij się, że newValue jest obiektem dayjs przed formatowaniem
            const dayjsValue = dayjs(newValue);
            const formattedDate = dayjsValue.isValid() ? dayjsValue.format(format) : '';
            onChange(formattedDate);
        } else {
            onChange(null);
        }
    };

    return (
        <Box sx={{ marginTop: 1.1, marginBottom: 1.4 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} fullWidth>
                <DatePicker
                    label={label}
                    name={name}
                    readOnly={readOnly}
                    renderInput={(params) => <TextField {...params} />}
                    value={value ? dayjs(value, format) : null}
                    minDate={dayjs(minDate)}
                    maxDate={dayjs('2030-12')}
                    format={format}
                    onChange={handleDateChange}
                    disabled={disabled}
                    disableOpenPicker={disableOpenPicker}
                    {...(views ? { views: Array.isArray(views) ? views : [views] } : {})}
                    slotProps={{
                        textField: {
                            error: error,
                            helperText: helperText,
                            fullWidth: true,
                            size: size
                        },
                        popper: {
                            popperOptions: {
                              modifiers: [
                                {
                                  name: 'applyCustom',
                                  enabled: true,
                                  phase: 'beforeWrite',
                                  requires: ['computeStyles'],
                                  fn: ({ state }: { state: Partial<any> }) => {
                                    state.styles.popper.height = '358px';
                                    if (state.placement.includes('top-start')) {
                                      state.styles.popper = {
                                        ...state.styles.popper,
                                        display: 'flex',
                                        alignItems: 'flex-end',
                                      };
                                    }
                                    if (state.placement.includes('bottom')) {
                                      state.styles.popper = {
                                        ...state.styles.popper,
                                        display: 'block',
                                      };
                                    }
                                  },
                                },
                              ],
                            }
                          },
                    }}
                />
            </LocalizationProvider>
        </Box>
    )
}